import { render, staticRenderFns } from "./TreeOptionNameLabel.vue?vue&type=template&id=2bc74cad&scoped=true"
import script from "./TreeOptionNameLabel.vue?vue&type=script&lang=js"
export * from "./TreeOptionNameLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc74cad",
  null
  
)

export default component.exports